import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  IconButton,
  Link,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import InstagramIcon from '@mui/icons-material/Instagram';

import { fonts, palette } from '../../../theme';

const InstagramMigrationModal = ({ open, handleClose }) => (
  <Dialog open={open} onClose={handleClose}>
    <Box display="flex" justifyContent="flex-end" alignItems="flex-end">
      <IconButton onClick={handleClose} sx={{ margin: '5px 5px 0 0' }}>
        <Close sx={{ fontSize: '1.2rem', color: palette.primary.main }} />
      </IconButton>
    </Box>
    <DialogContent style={{ maxWidth: 280, padding: '0 34px 30px' }}>
      <Box textAlign="center">
        <InstagramIcon sx={{ height: '65%', width: '65%' }} />
        <DialogContentText
          sx={{
            fontWeight: 500,
            fontSize: '1.5em',
            fontFamily: fonts.atypText,
            color: palette.primary.main,
          }}
        >
          Social Grid Notice
        </DialogContentText>
        <DialogContentText
          textAlign="center"
          sx={{ fontSize: '0.9rem', margin: '0.5em auto 1em', color: palette.primary.main }}
        >
          Instagram will discontinue API support for personal accounts on December 4th, 2024. To
          continue using Showit’s Social Grid feature, you must change your Instagram account to a
          Business or Creator account, and authorize the new Showit Social Grid app. <br />
          <Link
            href="https://news.showit.com/72428-instagram-changes-coming#"
            target="_blank"
            rel="noopener"
            sx={{ color: palette.primary.main, textDecoration: 'underline', cursor: 'pointer' }}
          >
            more details
          </Link>
        </DialogContentText>
        <Button
          title="Close Notice"
          type="submit"
          variant="contained"
          onClick={handleClose}
          fullWidth
        >
          Close
        </Button>
      </Box>
    </DialogContent>
  </Dialog>
);

InstagramMigrationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default InstagramMigrationModal;
